import { lazy } from 'react-loosely-lazy';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

// Temporary solution to integrate with the Universal Create button
// Since there is no entrypoint support in UC right now
export const LazyLoadedSmartCreationModal = lazy(() =>
	import(/* webpackChunkName: "async-jira-smart-creation" */ '../modal/index').then(
		(module) => module.SmartCreationModalInner,
	),
);

export const jiraSmartCreationEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-jira-smart-creation" */ '../modal/index'),
		{
			moduleId: 'async-jira-smart-creation',
		},
	),
	getPreloadProps: () => ({}),
});
